var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{class:_vm.theme === 'light' ? 'SkeletonBox':'SkeletonBoxDark',style:({ height: _vm.height, width: _vm.computedWidth })})])}
var staticRenderFns = []

export { render, staticRenderFns }